import { formatDate } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-advt-invoice-indetail-report',
  templateUrl: './advt-invoice-indetail-report.component.html',
  styleUrl: './advt-invoice-indetail-report.component.scss'
})
export class AdvtInvoiceIndetailReportComponent {
   startDate;
    endDate;
    today;
    issueName;
    issueDates;
    reportType;
    advtInvoiceData;
    filteredAdvtInvoiceData : any;
    isLoading = false;
    printShowData = [];
    filteredPrintShowData = [];
    sdate: any;
    enddate: any;
    invoiceNumber: any;
    issuedate: any;
    invoiceName: any;
    advtamount: any;
    discountamt: any;
    netamount: any;
    gstcst: any;
    totalinvoiceamount: any;
    paidamount: any;
    filteredAdvtInvoiceDatamonthly: any;
    netamountm: any;
    advtamountm: any;
    gstcstm: any;
    paidamountm: any;
    filteredAdvtInvoiceDatabrifly: any;
    beforegst: any;
    tcgst: any;
    tsgst: any;
    tigst: any;
    tgst: any;
    totalamount: any;
    cgst: number;
    sgst: number;
    igst: number;
    invoice_total: any;
    additionOfUnpaidAmount: number;
    totalbeforegstamount :number;
    offRepName:any;
    repName:any;
  
    constructor(
      private dialogRef: MatDialogRef<AdvtInvoiceIndetailReportComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private service: DigisubservicesService
    ) {}
  
    ngOnInit(): void {
      
      this.isLoading = false;
      this.today = new Date();
      this.startDate = this.data['startDate'];
      this.endDate = this.data['endDate'];
      this.issueName = this.data['issueName'];
      this.issueDates = this.data['issueDates'];
      this.reportType = this.data['reportType'];
      this.sdate = this.data['startDate'];
      this.enddate = this.data['endDate'];
      this.invoiceName = this.data['issueName'];
      this.issuedate = this.data['issueDates'];
      this.offRepName = this.data['off_rep_name'];
      this.repName = this.data['rep_name'];
      // this.advtInvoiceData = this.data['advtData'];
      // console.log(this.data);
  
      console.log(this.sdate, this.enddate, this.invoiceName, this.issuedate, "data");
  
      this.getData();
    }
  additionOfUnpaidAMount:number
   
    getData() {
      
 const req: any = {
    "start_date": this.sdate,
    "end_date": this.enddate,
    "issue_name": this.invoiceName,
    "issue_date": this.issuedate,
    "rep_name": this.repName?.length ? this.repName : "",
    "off_rep_name": this.offRepName?.length ? this.offRepName : "",
}
      this.service.getAdvtInvoiceRegisterList(req).subscribe((res: any) => {
        debugger
        console.log(res);
        debugger
        this.filteredAdvtInvoiceData = res;
        this.advtamount =0;
        this.discountamt =0;
        this.netamount =0;
        this.invoice_total =0;
        this.cgst =0;
        this.sgst =0;
        this.igst =0;
        this.gstcst =0;
        this.totalinvoiceamount =0;
        this.paidamount =0;
        this.additionOfUnpaidAMount=0;
        this.totalbeforegstamount = 0;
      //   for (let data1 of this.filteredAdvtInvoiceData) {
      //     console.log( data1.advt_amt, "advt amt")
      //     this.advtamount += parseInt(data1.advt_amt) || 0;
      //     this.discountamt += parseInt(data1.discount) || 0;
      //     this.netamount += parseInt(data1.net_amt) || 0;
      //     this.cgst += parseInt(data1.cgst) || 0;
      //     this.sgst += parseInt(data1.sgst) || 0;
      //     this.igst += parseInt(data1.igst) || 0;
      //     this.gstcst += parseInt(data1.gst) || 0;
      //     this.totalinvoiceamount += parseInt(data1.amount) || 0;
      //     this.paidamount += parseInt(data1.received_amt) || 0;
      // }
      for (let data1 of this.filteredAdvtInvoiceData) {
        console.log(data1.advt_amt, "advt amt");
        debugger
         const advtAmt = parseFloat(data1.advt_amt) || 0;
      const discountAmt = parseFloat(data1.discount) || 0;
      const beforegst_amt = parseFloat(data1.beforegst_amt) || 0;
      const netAmt = parseFloat(data1.net_amt) || 0;
      const invoiceTotal = parseFloat(data1.invoice_total) || 0;
      const cgstAmt = parseFloat(data1.cgst) || 0;
      const sgstAmt = parseFloat(data1.sgst) || 0;
      const igstAmt = parseFloat(data1.igst) || 0;
      const gstAmt = parseFloat(data1.gst) || 0;
      const totalInvoiceAmt = parseFloat(data1.amount) || 0;
      const paidAmt = parseFloat(data1.received_amt) || 0;
      const unpaidAmt = parseFloat(data1.unpaid_amount) || 0;
      
  
      // Add to totals (round after addition for better precision)
      this.advtamount += advtAmt;
      this.discountamt += discountAmt;
      this.netamount += netAmt;
      this.invoice_total += invoiceTotal;
      this.cgst += cgstAmt;
      this.sgst += sgstAmt;
      this.igst += igstAmt;
      this.gstcst += gstAmt;
      this.totalinvoiceamount += totalInvoiceAmt;
      this.totalbeforegstamount += beforegst_amt;
      this.paidamount += paidAmt;
      this.additionOfUnpaidAmount += unpaidAmt;
  
  
    } 
  
    
      console.log( this.advtamount, "total advt")
      });
  
      // this.service.getAdvtInvoiceRegisterListmonthly(req).subscribe((res: any) => {
      //   console.log(res);
      //   this.filteredAdvtInvoiceDatamonthly = res;
        
        
      // });
  
     
      
  
      // this.service.getAdvtInvoiceRegisterListbriefly(req).subscribe((res: any) => {
      //   console.log(res);
      //   this.filteredAdvtInvoiceDatabrifly = res;
      //   this.beforegst = 0;
      //   this.tcgst =  0;
      //   this.tsgst =  0;
      //   this.tigst =  0;
      //   this.tgst = 0;
      //   this.totalamount =0;
      //   for (let data1 of this.filteredAdvtInvoiceDatabrifly) {
         
      //     this.tcgst += parseInt(data1.cgst) || 0;
      //     this.tsgst += parseInt(data1.sgst) || 0;
      //     this.tigst += parseInt(data1.igst) || 0;
      //     this.tgst += parseInt(data1.gst) || 0;
      //     this.beforegst += parseInt(data1.beforegst_amt) || 0;
      //     this.totalamount += parseInt(data1.amount) || 0;
      // }
      // });
    }
  
    filterData() {
      // console.log('called');
      if (this.startDate == '' && this.endDate == '') {
        this.advtInvoiceData = this.filteredAdvtInvoiceData;
        // console.log('filteredData', this.advtInvoiceData);
      } else if (this.startDate !== '' && this.endDate !== '') {
        this.advtInvoiceData = this.filteredAdvtInvoiceData.filter((a) => {
          return (
            a['invoice_date'] >= this.startDate &&
            a['invoice_date'] <= this.endDate
          );
        });
        // console.log('filteredData', this.advtInvoiceData);
      }
  
      setTimeout(() => {
        this.setData();
      }, 700);
    }
  
    uniqueid(data, key) {
      return [...new Map(data.map((x) => [key(x), x])).values()];
    }
  
    setData() {
      // console.log(this.advtInvoiceData);
      // console.log(this.advtInvoiceData);
      if (this.advtInvoiceData.length == 0) {
        this.isLoading = false;
        alert('Data is not Present.');
        this.dialogRef.close();
      }
      let data = this.uniqueid(this.advtInvoiceData, (a) => a.advt_name);
      // console.log(data);
      for (let index = 0; index < this.advtInvoiceData.length; index++) {
        // let eachData = this.advtInvoiceData.filter(
        //   (a) => data[i]['advt_name'] == a.advt_name
        // );
  
        let showData = {
          issue_name: '',
          invoice_no: '',
          invoice_date: '',
          advt_name: '',
          client_name: '',
          rep_name: '',
          off_rep_name: '',
          firstweek_issue_date: '',
          secondweek_issue_date: '',
          thirdweek_issue_date: '',
          fourthweek_issue_date: '',
          fifthweek_issue_date: '',
          total_advt_amt: 0,
          total_dis: 0,
          total_net: 0,
          total_cgst: 0,
          total_sgst: 0,
          total_igst: 0,
          total_amt: 0,
        };
  
        // if (Object.keys(eachData).length > 0) {
        console.log('called', this.advtInvoiceData);
        // for (let index = 0; index < this.advtInvoiceData.length; index++) {
        if (
          this.advtInvoiceData[index]['first_week_id'] != null &&
          this.advtInvoiceData[index]['first_week_issue_name'] ===
            this.issueName &&
          this.issueDates.includes(
            this.advtInvoiceData[index]['first_week_date']
          )
        ) {
          console.log('first');
          showData['issue_name'] =
            this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
            console.log(  showData['issue_name'], "new issue name");
  
          showData['firstweek_issue_date'] =
            this.advtInvoiceData[index]['first_week_issue_date'].split(',')[0];
          showData['total_advt_amt'] += parseInt(
            this.advtInvoiceData[index]['first_week_advt_amt']
          );
          showData['total_dis'] += parseInt(
            this.advtInvoiceData[index]['first_week_advt_discnt']
          );
          showData['total_net'] += parseInt(
            this.advtInvoiceData[index]['first_week_amount']
          );
          showData['total_cgst'] += parseInt(
            this.advtInvoiceData[index]['first_week_cgst']
          );
          showData['total_sgst'] += parseInt(
            this.advtInvoiceData[index]['first_week_sgst']
          );
          showData['total_igst'] += parseInt(
            this.advtInvoiceData[index]['first_week_igst']
          );
          showData['total_amt'] += parseInt(
            this.advtInvoiceData[index]['first_week_total_amount']
          );
        } else if (
          this.advtInvoiceData[index]['second_week_id'] != null &&
          this.advtInvoiceData[index]['second_week_issue_name'] ===
            this.issueName &&
          this.issueDates.includes(
            this.advtInvoiceData[index]['second_week_date']
          )
        ) {
          debugger
          showData['issue_name'] =
            this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
          showData['secondweek_issue_date'] =
            this.advtInvoiceData[index]['second_week_issue_date'].split(',')[0];
          showData['total_advt_amt'] += parseInt(
            this.advtInvoiceData[index]['second_week_advt_amt']
          );
          showData['total_dis'] += parseInt(
            this.advtInvoiceData[index]['second_week_advt_discnt']
          );
          showData['total_net'] += parseInt(
            this.advtInvoiceData[index]['second_week_amount']
          );
          showData['total_cgst'] += parseInt(
            this.advtInvoiceData[index]['second_week_cgst']
          );
          showData['total_sgst'] += parseInt(
            this.advtInvoiceData[index]['second_week_sgst']
          );
          showData['total_igst'] += parseInt(
            this.advtInvoiceData[index]['second_week_igst']
          );
          showData['total_amt'] += parseInt(
            this.advtInvoiceData[index]['second_week_total_amount']
          );
        } else if (
          this.advtInvoiceData[index]['third_week_id'] != null &&
          this.advtInvoiceData[index]['third_week_issue_name'] ===
            this.issueName &&
          this.issueDates.includes(
            this.advtInvoiceData[index]['third_week_date']
          )
        ) {
          showData['issue_name'] =
            this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
          showData['thirdweek_issue_date'] =
            this.advtInvoiceData[index]['third_week_issue_date'].split(',')[0];
          showData['total_advt_amt'] += parseInt(
            this.advtInvoiceData[index]['third_week_advt_amt']
          );
          showData['total_dis'] += parseInt(
            this.advtInvoiceData[index]['third_week_advt_discnt']
          );
          showData['total_net'] += parseInt(
            this.advtInvoiceData[index]['third_week_amount']
          );
          showData['total_cgst'] += parseInt(
            this.advtInvoiceData[index]['third_week_cgst']
          );
          showData['total_sgst'] += parseInt(
            this.advtInvoiceData[index]['third_week_sgst']
          );
          showData['total_igst'] += parseInt(
            this.advtInvoiceData[index]['third_week_igst']
          );
          showData['total_amt'] += parseInt(
            this.advtInvoiceData[index]['third_week_total_amount']
          );
        } else if (
          this.advtInvoiceData[index]['fourth_week_id'] != null &&
          this.advtInvoiceData[index]['fourth_week_issue_name'] ===
            this.issueName &&
          this.issueDates.includes(
            this.advtInvoiceData[index]['fourth_week_date']
          )
        ) {
          showData['issue_name'] =
            this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
          showData['fourthweek_issue_date'] =
            this.advtInvoiceData[index]['fourth_week_issue_date'].split(',')[0];
          showData['total_advt_amt'] += parseInt(
            this.advtInvoiceData[index]['fourth_week_advt_amt']
          );
          showData['total_dis'] += parseInt(
            this.advtInvoiceData[index]['fourth_week_advt_discnt']
          );
          showData['total_net'] += parseInt(
            this.advtInvoiceData[index]['fourth_week_amount']
          );
          showData['total_cgst'] += parseInt(
            this.advtInvoiceData[index]['fourth_week_cgst']
          );
          showData['total_sgst'] += parseInt(
            this.advtInvoiceData[index]['fourth_week_sgst']
          );
          showData['total_igst'] += parseInt(
            this.advtInvoiceData[index]['fourth_week_igst']
          );
          showData['total_amt'] += parseInt(
            this.advtInvoiceData[index]['fourth_week_total_amount']
          );
        } else if (
          this.advtInvoiceData[index]['fifth_week_id'] != null &&
          this.advtInvoiceData[index]['fifth_week_issue_name'] ===
            this.issueName &&
          this.issueDates.includes(
            this.advtInvoiceData[index]['fifth_week_date']
          )
        ) {
          showData['issue_name'] =
            this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
          showData['fifthweek_issue_date'] =
            this.advtInvoiceData[index]['fifth_week_issue_date'].split(',')[0];
          showData['total_advt_amt'] += parseInt(
            this.advtInvoiceData[index]['fifth_week_advt_amt']
          );
          showData['total_dis'] += parseInt(
            this.advtInvoiceData[index]['fifth_week_advt_discnt']
          );
          showData['total_net'] += parseInt(
            this.advtInvoiceData[index]['fifth_week_amount']
          );
          showData['total_cgst'] += parseInt(
            this.advtInvoiceData[index]['fifth_week_cgst']
          );
          showData['total_sgst'] += parseInt(
            this.advtInvoiceData[index]['fifth_week_sgst']
          );
          showData['total_igst'] += parseInt(
            this.advtInvoiceData[index]['fifth_week_igst']
          );
          showData['total_amt'] += parseInt(
            this.advtInvoiceData[index]['fifth_week_total_amount']
          );
        }
        // }
        if (
          (this.advtInvoiceData[index]['first_week_issue_name'] ===
            this.issueName &&
            this.issueDates.includes(
              this.advtInvoiceData[index]['first_week_issue_date']
            )) ||
          (this.advtInvoiceData[index]['second_week_issue_name'] ===
            this.issueName &&
            this.issueDates.includes(
              this.advtInvoiceData[index]['second_week_issue_date']
            )) ||
          (this.advtInvoiceData[index]['third_week_issue_name'] ===
            this.issueName &&
            this.issueDates.includes(
              this.advtInvoiceData[index]['third_week_issue_date']
            )) ||
          (this.advtInvoiceData[index]['fourth_week_issue_name'] ===
            this.issueName &&
            this.issueDates.includes(
              this.advtInvoiceData[index]['fourth_week_issue_date']
            )) ||
          (this.advtInvoiceData[index]['fifth_week_issue_name'] ===
            this.issueName &&
            this.issueDates.includes(
              this.advtInvoiceData[index]['fifth_week_issue_date']
            ))
        ) {
          showData['invoice_no'] = this.advtInvoiceData[0]['invoice_no'];
          showData['invoice_date'] = this.advtInvoiceData[0]['invoice_date'];
          showData['advt_name'] = this.advtInvoiceData[0]['advt_name'];
          showData['client_name'] = this.advtInvoiceData[0]['cust_name'];
          showData['rep_name'] = this.advtInvoiceData[0]['rep_name'];
          showData['off_rep_name'] = this.advtInvoiceData[0]['off_rep_name'];
  
          this.printShowData.push(showData);
        }
  
        // console.log('showData', showData);
        // }
        console.log('printShowData', this.printShowData);
        if (index == data.length - 1) {
          this.isLoading = false;
          this.filterPrintShowData();
        }
      }
    }
  
    filterPrintShowData() {
      let data = this.uniqueid(this.printShowData, (a) =>
        formatDate(a.invoice_date, 'MM', 'en-IN', 'GMT+0530')
      );
      // console.log(data);
      let totalAdvtAmt1 = 0;
      let totalDisAmt1 = 0;
      let totalNetAmt1 = 0;
      let totalCGST1 = 0;
      let totalSGST1 = 0;
      let totalIGST1 = 0;
      let totalInvoiceAmount1 = 0;
      for (let index = 0; index < data.length; index++) {
        let filteredData = this.printShowData.filter((a) => {
          return (
            formatDate(a.invoice_date, 'MM', 'en-IN', 'GMT+0530') ==
            formatDate(data[index]['invoice_date'], 'MM', 'en-IN', 'GMT+0530')
          );
        });
        // console.log(filteredData);
        let totalAdvtAmt = 0;
        let totalDisAmt = 0;
        let totalNetAmt = 0;
        let totalCGST = 0;
        let totalSGST = 0;
        let totalIGST = 0;
        let totalInvoiceAmount = 0;
        let issue_date = '';
        for (let i = 0; i < filteredData.length; i++) {
          totalAdvtAmt += parseInt(filteredData[index]['total_advt_amt']);
          totalDisAmt += parseInt(filteredData[index]['total_dis']);
          totalNetAmt += parseInt(filteredData[index]['total_net']);
          totalCGST += parseInt(filteredData[index]['total_cgst']);
          totalSGST += parseInt(filteredData[index]['total_sgst']);
          totalIGST += parseInt(filteredData[index]['total_igst']);
          totalInvoiceAmount += parseInt(filteredData[index]['total_amt']);
          issue_date = filteredData[index]['invoice_date'];
        }
  
        filteredData.push({
          issue_date,
          totalAdvtAmt,
          totalDisAmt,
          totalNetAmt,
          totalCGST,
          totalSGST,
          totalIGST,
          totalInvoiceAmount,
        });
  
        totalAdvtAmt1 += totalAdvtAmt;
        totalDisAmt1 += totalDisAmt;
        totalNetAmt1 += totalNetAmt;
        totalCGST1 += totalCGST;
        totalSGST1 += totalSGST;
        totalIGST1 += totalIGST;
        totalInvoiceAmount1 = totalInvoiceAmount;
  
        this.filteredPrintShowData.push(filteredData);
      }
  
      this.filteredPrintShowData.push({
        totalAdvtAmt1,
        totalDisAmt1,
        totalNetAmt1,
        totalCGST1,
        totalSGST1,
        totalIGST1,
        totalInvoiceAmount1,
      });
  
      console.log(this.filteredPrintShowData);
    }
  
    exportExcel(fileName) {
      /* table id is passed over here */
      let element = document.getElementById('print-section');
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
      /* save to file */
      XLSX.writeFile(wb, fileName + '.xlsx');
    }
  
    issuedatereturn(dates){
      if(dates!=null){
        let returnissuedate = dates.split(',');
        return returnissuedate[0];
      }else{
        return null;
      }
    
    }
    // print() {
    //   const originalTitle = document.title; // Store original title
    //   document.title = '';     // Set custom print title
    
    //   // Create a style tag for print-specific styles
    //   const style = document.createElement('style');
    //   style.innerHTML = `
    //     @media print {
    //       @page {
    //         size: A4;
    //         margin: 20mm;
    //       }
    //       .print-header {
    //         text-align: center;
    //         font-size: 16px;
    //         font-weight: bold;
    //         margin-bottom: 10px;
    //       }
    //       .print-footer {
    //         position: fixed;
    //         bottom: 10px;
    //         left: 0;
    //         right: 0;
    //         text-align: center;
    //         font-size: 12px;
    //         color: gray;
    //       }
    //       .print-footer::after {
    //         content: "Page " counter(page) " of " counter(pages);
    //       }
    //       .no-print {
    //         display: none !important;
    //       }
    //     }
    //   `;
    
    //   document.head.appendChild(style); // Add style to the document
    
    //   setTimeout(() => {
    //     const printTrigger = document.getElementById('print-button');
    //     if (printTrigger) (printTrigger as HTMLElement).click();
        
    //     document.title = ''; // Restore original title after printing
        
    //     // document.head.removeChild(style); // Remove the style after printing
    //   }, 500); // Delay ensures styles apply before printing
    // }
  
    
   show = false
  //  printPage() {
  //   this.show = true;
  //   const printContent = document.getElementById('print-section')?.outerHTML;
  //   if (!printContent) {
  //     console.error("Print section not found!");
  //     return;
  //   }
  
  //   const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');
  
  //   if (printWindow) {
  //     printWindow.document.open();
  //     printWindow.document.write(`
  //       <html>
  //         <head>
  //           <title>Print Report</title>
  //           <style>
  //             @media print {
  //               @page {
  //                 size: A3 landscape;
  //                 margin: 5mm;
  //               }
  
  //               html, body {
  //                 width: 100%;
  //                 height: 100%;
  //                 margin: 0;
  //                 padding: 0;
  //                 font-family: Arial, sans-serif;
  //                 font-size: 10px;
  //                 line-height: 1.1;
  //                 -webkit-print-color-adjust: exact;
  //                 print-color-adjust: exact;
  //                 overflow: hidden;
  //               }
  
  //               * {
  //                 box-sizing: border-box;
  //               }
  
  //               #print-section {
  //                 width: 100%;
  //                 height: 100%;
  //                 overflow: hidden;
  //                 page-break-inside: avoid;
  //               }
  
  //               table {
  //                 width: 100%;
  //                 border-collapse: collapse;
  //                 table-layout: fixed;
  //                 font-size: 10px;
  //                 page-break-inside: avoid;
  //               }
  
  //               th, td {
  //                 padding: 3px 2px;
  //                 border: 1px solid #000;
  //                 text-align: center;
  //                 font-size: 10px;
  //                 line-height: 1.1;
  //                 white-space: nowrap;
  //                 overflow: hidden;
  //                 text-overflow: ellipsis;
  //                 vertical-align: middle;
  //                 word-wrap: break-word;
  //                 hyphens: auto;
  //               }
  
  //               th {
  //                 background-color: #f0f0f0;
  //                 font-weight: bold;
  //               }
  
  //               /* Prevent text wrapping in cells */
  //               .no-wrap {
  //                 white-space: nowrap !important;
  //               }
  
  //               /* Hide non-essential elements */
  //               .noPrint, .no-print {
  //                 display: none !important;
  //               }
  
  //               /* Ensure proper spacing */
  //               tr {
  //                 page-break-inside: avoid;
  //               }
  
  //               /* Adjust column widths if needed */
  //               .col-narrow {
  //                 width: 5%;
  //               }
  
  //               .col-medium {
  //                 width: 10%;
  //               }
  
  //               .col-wide {
  //                 width: 15%;
  //               }
  
  //               /* Remove any margins/padding that might cause overlap */
  //               div, span, p {
  //                 margin: 0;
  //                 padding: 0;
  //               }
  
  //               /* Ensure content fits within bounds */
  //               .content-container {
  //                 max-width: 100%;
  //                 overflow: hidden;
  //               }
  //             }
  
  //             /* Screen styles for preview */
  //             @media screen {
  //               body {
  //                 font-family: Arial, sans-serif;
  //                 margin: 20px;
  //               }
  
  //               table {
  //                 width: 100%;
  //                 border-collapse: collapse;
  //                 margin: 10px 0;
  //               }
  
  //               th, td {
  //                 padding: 8px;
  //                 border: 1px solid #ddd;
  //                 text-align: left;
  //               }
  
  //               th {
  //                 background-color: #f2f2f2;
  //               }
  //             }
  //           </style>
  //         </head>
  //         <body>
  //           <div id="print-section" class="content-container">
  //             ${printContent}
  //           </div>
  //           <script>
  //             window.onload = function() {
  //               // Small delay to ensure styles are applied
  //               setTimeout(() => {
  //                 window.print();
  //                 setTimeout(() => { window.close(); }, 1000);
  //               }, 100);
  //             };
  //           </script>
  //         </body>
  //       </html>
  //     `);
  //     printWindow.document.close();
  //   } else {
  //     console.error("Failed to open print window.");
  //   }
  // }
// show = false
  // printPage() {
  //        this.show = true;
  //        const printSection = document.getElementById('print-section');
  //        if (!printSection) {
  //            console.error("Print section not found!");
  //            return;
  //        }
       
  //        const printContent = printSection.innerHTML;
       
  //        const screenWidth = window.screen.availWidth;
     
  //        const windowWidth = 1000;
  //        const leftPosition = screenWidth - windowWidth - 50;
       
  //        const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);
       
         
  //        if (printWindow) {
  //            printWindow.document.open();
  //            printWindow.document.write(`
  //                <html>
  //                    <head>
  //                        <title>Print Report</title>
  //                        <style>
  //                            @media print {
  //                                @page {
  //                                    size: A3 landscape;
  //                                    margin: 5mm;
  //                                }
  //                                body {
  //                                    font-family: Arial, sans-serif;
  //                                    margin: 0;
  //                                    padding: 0;
  //                                    font-size: 14px !important;
  //                                }
  //                                .print-section {
  //                                    width: 100%;
  //                                    margin: 0 auto;
  //                                    padding: 0;
  //                                }
  //                                table {
  //                                    width: auto !important;
  //                                    border-collapse: collapse;
  //                                    table-layout: auto;
  //                                    page-break-inside: auto;
  //                                    border: 1px solid black !important;
  //                                }
  //                                tr {
  //                                    page-break-inside: avoid;
  //                                    page-break-after: auto;
  //                                }
  //                                th, td {
  //                                    padding: 2px 3px !important;
  //                                    border: 1px solid black !important;
  //                                    font-size: 14px;
  //                                    line-height: 1.2;
  //                                    white-space: nowrap;
  //                                }
  //                                th {
  //                                    background-color: #f2f2f2;
  //                                    font-weight: bold;
  //                                }
  //                                tr {
  //                                    border-bottom: 1px solid black !important;
  //                                }
  //                                tr.header-row {
  //                                    display: table-header-group;
  //                                }
  //                                td[data-type="number"],
  //                                td.amount,
  //                                td.balance-value,
  //                                td:nth-child(n+12) {
  //                                    text-align: end !important;
  //                                }
  //                                td.text,
  //                                td[data-type="string"] {
  //                                    text-align: left !important;
  //                                }
  //                                .br-right { border-right: 1px solid black !important; }
  //                                .br-rightt { border-right: 1px solid black !important; }
  //                                .br-bottom { border-bottom: 1px solid black !important; }
  //                                .br-top { border-top: 1px solid black !important; }
  //                                .noPrint { display: none !important; }
  //                                .footer-line {
  //                                    position: fixed;
  //                                    bottom: 0;
  //                                    left: 0;
  //                                    width: 100%;
  //                                    height: 1px;
  //                                    background-color: black;
  //                                }
  //                                thead { 
  //                                    display: table-header-group; 
  //                                    border: 1px solid black !important;
  //                                }
  //                                tfoot { 
  //                                    display: table-footer-group; 
  //                                    border: 1px solid black !important;
  //                                }
  //                                /* Ensure all borders are displayed */
  //                                table, th, td {
  //                                    border-style: solid !important;
  //                                    border-width: 1px !important;
  //                                    border-color: black !important;
  //                                }
  //                                /* Make sure header repeats on each page */
  //                                thead tr {
  //                                    display: table-row !important;
  //                                }
  //                            }
  //                        </style>
  //                    </head>
  //                    <body>
  //                        <div class="print-section">
  //                            ${printContent}
  //                            <div class="footer-line"></div>
  //                        </div>
  //                        <script>
  //                           window.onload = function () {
  //                               const table = document.querySelector('table');
  //                               if (!table) {
  //                                   console.error("Table not found");
  //                                   return;
  //                               }
     
  //                               // Auto-size columns based on content
  //                               table.style.width = 'auto';
  //                               const cols = table.querySelectorAll('td, th');
  //                               cols.forEach(cell => {
  //                                   cell.style.width = 'auto';
  //                                   cell.style.whiteSpace = 'nowrap';
  //                               });
     
  //                               let headerRowIndex = -1;
  //                               const maxRowsToCheck = Math.min(10, table.rows.length);
     
  //                               // Find header row with column names
  //                               for (let i = 0; i < maxRowsToCheck; i++) {
  //                                   const row = table.rows[i];
  //                                   const cellTexts = Array.from(row.cells).map(cell => cell.textContent.trim());
     
  //                                   if (row.cells.length >= 8 &&
  //                                       (cellTexts.includes('Invoice No') ||
  //                                        cellTexts.includes('Receipt No') ||
  //                                        cellTexts.includes('Balance'))) {
  //                                       headerRowIndex = i;
  //                                       break;
  //                                   }
  //                               }
     
  //                               if (headerRowIndex >= 0) {
  //                                   // Create thead and move only the actual header row into it
  //                                   let thead = table.querySelector('thead');
  //                                   if (!thead) {
  //                                       thead = document.createElement('thead');
  //                                       table.insertBefore(thead, table.firstChild);
  //                                   }
     
  //                                   const headerRow = table.rows[headerRowIndex];
  //                                   thead.appendChild(headerRow.cloneNode(true));
  //                               }
     
  //                               // Alignment processing
  //                               const cells = document.querySelectorAll('td');
  //                               cells.forEach(cell => {
  //                                   const content = cell.textContent.trim();
     
  //                                   if (content.includes('येणे') ||
  //                                       content.includes('Opening Balance') ||
  //                                       content.match(/^\\d+\\s+येणे$/) ||
  //                                       content.includes('Balance C/F') ||
  //                                       content.includes('Total')) {
  //                                       cell.style.textAlign = 'right';
  //                                       cell.classList.add('balance-value');
  //                                   }
     
  //                                   const numericPattern = /^-?\\d+(,\\d{3})*(\\.\\d+)?$/;
  //                                   if (numericPattern.test(content.replace(/[\\s,]/g, ''))) {
  //                                       cell.style.textAlign = 'right';
  //                                       cell.classList.add('amount');
  //                                   }
     
  //                                   cell.style.border = '1px solid black';
  //                               });
     
  //                               setTimeout(() => {
  //                                   window.print();
  //                                   setTimeout(() => { window.close(); }, 500);
  //                               }, 200);
  //                           };
  //                        </script>
  //                    </body>
  //                </html>
  //            `);
  //            printWindow.document.close();
  //        } else {
  //            console.error("Failed to open print window.");
  //        }
  //    }

printPage() {
    this.show = true;
    const printSection = document.getElementById('print-section');
    if (!printSection) {
        console.error("Print section not found!");
        return;
    }
  
    const printContent = printSection.innerHTML;
  
    const screenWidth = window.screen.availWidth;

    const windowWidth = 1000;
    const leftPosition = screenWidth - windowWidth - 50;
  
    const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);
  
    
    if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(`
            <html>
                <head>
                    <title>Print Report</title>
                    <style>
                        @media print {
                            @page {
                                size: A3 landscape;
                                margin: 5mm;
                            }
                            body {
                                font-family: Arial, sans-serif;
                                margin: 0;
                                padding: 0;
                                font-size: 14px !important;
                            }
                            .print-section {
                                width: 100%;
                                margin: 0 auto;
                                padding: 0;
                            }
                            table {
                                width: auto !important;
                                border-collapse: collapse;
                                table-layout: auto;
                                page-break-inside: auto;
                                border: 2px solid black !important; /* Thicker outer border */
                            }
                            tr {
                                page-break-inside: avoid;
                                page-break-after: auto;
                            }
                            th, td {
                                padding: 2px 3px !important;
                                border: 1px solid black !important;
                                font-size: 14px;
                                line-height: 1.2;
                                white-space: nowrap;
                            }
                            /* Ensure the rightmost column has a proper right border */
                            tr td:last-child,
                            tr th:last-child {
                                border-right: 2px solid black !important;
                            }
                            /* Ensure the top row has proper top border */
                            tr:first-child td,
                            tr:first-child th {
                                border-top: 2px solid black !important;
                            }
                            /* Ensure the leftmost column has proper left border */
                            tr td:first-child,
                            tr th:first-child {
                                border-left: 2px solid black !important;
                            }
                            /* Ensure the bottom row has proper bottom border */
                            tr:last-child td,
                            tr:last-child th {
                                border-bottom: 2px solid black !important;
                            }
                            th {
                                background-color: #f2f2f2;
                                font-weight: bold;
                            }
                            tr {
                                border-bottom: 1px solid black !important;
                            }
                            tr.header-row {
                                display: table-header-group;
                            }
                            td[data-type="number"],
                            td.amount,
                            td.balance-value,
                            td:nth-child(n+12) {
                                text-align: end !important;
                            }
                            td.text,
                            td[data-type="string"] {
                                text-align: left !important;
                            }
                            .br-right { border-right: 1px solid black !important; }
                            .br-rightt { border-right: 1px solid black !important; }
                            .br-bottom { border-bottom: 1px solid black !important; }
                            .br-top { border-top: 1px solid black !important; }
                            .noPrint { display: none !important; }
                            .footer-line {
                                position: fixed;
                                bottom: 0;
                                left: 0;
                                width: 100%;
                                height: 1px;
                                background-color: black;
                            }
                            thead { 
                                display: table-header-group; 
                                border: 2px solid black !important;
                            }
                            tfoot { 
                                display: table-footer-group; 
                                border: 2px solid black !important;
                            }
                            /* Ensure all borders are displayed */
                            table, th, td {
                                border-style: solid !important;
                                border-width: 1px !important;
                                border-color: black !important;
                            }
                            /* Make sure header repeats on each page */
                            thead tr {
                                display: table-row !important;
                            }
                        }
                    </style>
                </head>
                <body>
                    <div class="print-section">
                        ${printContent}
                        <div class="footer-line"></div>
                    </div>
                    <script>
                       window.onload = function () {
                           const table = document.querySelector('table');
                           if (!table) {
                               console.error("Table not found");
                               return;
                           }

                           // Auto-size columns based on content
                           table.style.width = 'auto';
                           const cols = table.querySelectorAll('td, th');
                           cols.forEach(cell => {
                               cell.style.width = 'auto';
                               cell.style.whiteSpace = 'nowrap';
                           });

                           let headerRowIndex = -1;
                           const maxRowsToCheck = Math.min(10, table.rows.length);

                           // Find header row with column names
                           for (let i = 0; i < maxRowsToCheck; i++) {
                               const row = table.rows[i];
                               const cellTexts = Array.from(row.cells).map(cell => cell.textContent.trim());

                               if (row.cells.length >= 8 &&
                                   (cellTexts.includes('Invoice No') ||
                                    cellTexts.includes('Receipt No') ||
                                    cellTexts.includes('Balance'))) {
                                   headerRowIndex = i;
                                   break;
                               }
                           }

                           if (headerRowIndex >= 0) {
                               // Create thead and move only the actual header row into it
                               let thead = table.querySelector('thead');
                               if (!thead) {
                                   thead = document.createElement('thead');
                                   table.insertBefore(thead, table.firstChild);
                               }

                               const headerRow = table.rows[headerRowIndex];
                               thead.appendChild(headerRow.cloneNode(true));
                           }

                           // Alignment processing
                           const cells = document.querySelectorAll('td');
                           cells.forEach(cell => {
                               const content = cell.textContent.trim();

                               if (content.includes('येणे') ||
                                   content.includes('Opening Balance') ||
                                   content.match(/^\\d+\\s+येणे$/) ||
                                   content.includes('Balance C/F') ||
                                   content.includes('Total')) {
                                   cell.style.textAlign = 'right';
                                   cell.classList.add('balance-value');
                               }

                               const numericPattern = /^-?\\d+(,\\d{3})*(\\.\\d+)?$/;
                               if (numericPattern.test(content.replace(/[\\s,]/g, ''))) {
                                   cell.style.textAlign = 'right';
                                   cell.classList.add('amount');
                               }

                               cell.style.border = '1px solid black';
                           });

                           // Force outer border on table after all processing
                           setTimeout(() => {
                               table.style.border = '2px solid black';
                               
                               // Ensure rightmost cells have thick right border
                               const rows = table.querySelectorAll('tr');
                               rows.forEach(row => {
                                   const lastCell = row.querySelector('td:last-child, th:last-child');
                                   if (lastCell) {
                                       lastCell.style.borderRight = '2px solid black';
                                   }
                               });
                               
                           }, 100);

                           setTimeout(() => {
                               window.print();
                               setTimeout(() => { window.close(); }, 500);
                           }, 200);
                       };
                    </script>
                </body>
            </html>
        `);
        printWindow.document.close();
    } else {
        console.error("Failed to open print window.");
    }
}

}
